import { Body } from "@biom3/react";
import Image from "next/image";
import { useCallback, useState } from "react";

type AppStoreImageExampleProps = {
  text: string;
  storeType?: "ios" | "google";
  imageUrl: string;
};

export function AppStoreImageExample({
  text,
  imageUrl,
}: AppStoreImageExampleProps) {
  const [isImageExpanded, setIsImageExpanded] = useState(false);

  const handleImageClick = useCallback(() => {
    setIsImageExpanded(!isImageExpanded);
  }, [isImageExpanded]);

  const handleExampleClick = useCallback(() => {
    setIsImageExpanded(true);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={handleExampleClick}
        style={{
          color: "var(--color-accent-2)",
          cursor: "pointer",
          textDecoration: "underline",
          background: "none",
          border: "none",
          padding: 0,
          font: "inherit",
        }}
      >
        {text}
      </button>
      {isImageExpanded && imageUrl && (
        <>
          <Image
            src={imageUrl}
            alt={"purchase-history-example"}
            width={800}
            height={600}
            onClick={handleImageClick}
            style={{
              cursor: "pointer",
              borderRadius: "8px",
              border: "1px solid var(--color-translucent-standard-400)",
              backgroundColor: "var(--color-translucent-standard-100)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
              maxWidth: "90vw",
              maxHeight: "90vh",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
          />
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              zIndex: 9998,
              cursor: "pointer",
              animation: "fadeIn 0.3s ease",
            }}
            onClick={handleImageClick}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
                handleImageClick();
              }
            }}
            tabIndex={0}
            role="button"
            aria-label="Close image overlay"
          />
          <Body
            size="xSmall"
            sx={{
              color: "base.color.text.body.secondary",
              textAlign: "center",
              fontStyle: "italic",
              position: "fixed",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10000,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              padding: "8px 16px",
              borderRadius: "4px",
            }}
          >
            Click anywhere to close
          </Body>
        </>
      )}
    </>
  );
}
